<div>
  <span class="stats-name">{{ name }}: </span>
  <span class="stats-value">{{ value }}</span>
</div>
